import http from "../../services/http";

const getVagas = async () => {
  return await http("get", `v1/vagas/listar`, []);
};

const getVagasDisponiveis = async () => {
  return await http("get", `v1/curriculos_vagas/listar`, []);
};

const addCurriculosVagas = async (formData) => {
  return await http("post", `v1/curriculos_vagas/adicionar`, formData);
};

export { getVagas, getVagasDisponiveis, addCurriculosVagas };
